import type { PausedForkStatus } from "@gearbox-protocol/deploy-tools-shared";
import {
  CopyToClipboard,
  NetworkLogo,
} from "@gearbox-protocol/deploy-tools-ui";
import { ADDRESS_0X0 } from "@gearbox-protocol/sdk/onchain";
import GrafanaLink from "components/GrafanaLink";
import type { FC } from "react";
import { ScriptTemplate } from "./Script";

export interface PausedForkStatusRouteProps {
  fork: PausedForkStatus;
}

export const PausedForkStatusRoute: FC<PausedForkStatusRouteProps> = ({
  fork,
}) => {
  const { alias, options } = fork;
  const { addressProvider, marketConfigurators, scripts } = options;

  return (
    <div className="flex flex-col flex-1 rounded-xl bg-background p-4">
      <table className="table-auto border-collapse border border-slate-500">
        <tbody>
          <tr>
            <td className="border border-slate-500 p-2">Network</td>
            <td className="border border-slate-500 p-2">
              <NetworkLogo network={options.network} />
              <span>{options.network}</span>
            </td>
          </tr>

          <tr>
            <td className="border border-slate-500 p-2">Logs</td>
            <td className="border border-slate-500 p-2 ">
              <div className="flex flex-row items-center gap-2 divide-x *:px-1 -mx-1 divide-slate-500">
                <GrafanaLink labels={{ alias: alias ?? "" }}>
                  Grafana
                </GrafanaLink>
              </div>
            </td>
          </tr>

          <tr>
            <td className="border border-slate-500 p-2">Address provider</td>
            <td className="border border-slate-500 p-2">
              {!addressProvider || addressProvider === ADDRESS_0X0 ? (
                "-"
              ) : (
                <>
                  <span>{addressProvider}</span>
                  <span>
                    <CopyToClipboard text={addressProvider} />
                  </span>
                </>
              )}
            </td>
          </tr>

          {!!marketConfigurators?.length && (
            <tr>
              <td className="border border-slate-500 p-2">
                Market configurators
              </td>
              <td className="border border-slate-500 p-2">
                <div className="flex flex-row items-center gap-2 flex-wrap">
                  {marketConfigurators.map(mc => (
                    <div key={mc} className="flex flex-row items-center gap-1">
                      <span>{mc}</span>
                      <CopyToClipboard text={mc} />
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          )}

          {!!scripts?.length && (
            <tr>
              <td className="border border-slate-500 p-2 align-top">
                Scripts:
              </td>
              <td className="border border-slate-500 p-2">
                <ul>
                  {scripts.map(s => (
                    <ScriptTemplate key={s.id} script={s} />
                  ))}
                </ul>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
